import React from 'react';
import { useIntl } from 'umi';
import SteamTagsSelector from '@intelligence/components/SteamTagsSelector';
import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';
import { getPreviewTitle, renderOptionSummary } from '../previewHelpers';
import { getStringArrayValue } from '../shared/valueUtils';
import { FILTER_TYPE } from '../filterTypes';

import type { IFilterRenderProps, IFilterTypeEntry } from '@intelligence/v3/filterCore/registry';
import type { IFilterControlModule } from '../controlModule';
import type { IPublisherClassSelectFilterValue } from './types';

const getDataSourceTipIcon = (source: string): React.ReactNode => {
  return <img style={{ verticalAlign: 'middle' }} src={getDataSourceIcon(source)} alt="" />;
};

const DEFAULT_SELECTOR_CONFIG = {
  placeholder: 'dbi_top_publisher_class_placeholder',
  searchPlaceholder: 'dbi_top_publisher_class_search_placeholder',
  label: 'dbi_publisher_class',
  tipLabel: 'dbi_publisher_class',
  tipText: 'dbi_top_publisher_class_tip',
  tipTextParams: {
    gamalyticDataSourceIcon: getDataSourceTipIcon('gamalytic'),
    alineaDataSourceIcon: getDataSourceTipIcon('alinea'),
    mscienceDataSourceIcon: getDataSourceTipIcon('mscience'),
  },
};

const PublisherClassSelectRenderer: React.FC<IFilterRenderProps<IPublisherClassSelectFilterValue>> = (props) => {
  const { field, AWidth: aWidth = 440, selectorConfig, options = [], value, onChange, ...rest } = props;

  return (
    // @ts-ignore
    <SteamTagsSelector
      {...rest}
      key={field}
      AWidth={aWidth}
      showLogicSelector={false}
      selectorConfig={selectorConfig || DEFAULT_SELECTOR_CONFIG}
      options={options}
      value={getStringArrayValue(value)}
      onConfirm={(payload?: string[]) => {
        onChange?.(payload || []);
      }}
    />
  );
};

const PublisherClassPreview: React.FC<{
  item: Parameters<NonNullable<IFilterTypeEntry['renderPreview']>>[0];
  valueItem: any;
}> = (props) => {
  const { item, valueItem } = props;
  const { locale, formatMessage } = useIntl();
  const options = item?.controlProps?.options || [];

  return (
    <>
      <span className="model-form-text">{getPreviewTitle(item, formatMessage)}</span>
      <span className="model-form-context">{renderOptionSummary(valueItem, options, formatMessage, locale)}</span>
    </>
  );
};

function renderPublisherClassPreview(
  item: Parameters<NonNullable<IFilterTypeEntry['renderPreview']>>[0],
  value: any,
): React.ReactNode {
  return <PublisherClassPreview item={item} valueItem={value} />;
}

const getRenderPreview = (): NonNullable<IFilterTypeEntry['renderPreview']> => {
  return renderPublisherClassPreview;
};

export const publisherClassSelectControl: IFilterControlModule = {
  type: FILTER_TYPE.PUBLISHER_CLASS_SELECT,
  entry: {
    render: (props) => {
      return <PublisherClassSelectRenderer {...props} />;
    },
  },
  getRenderPreview,
};
